import { render, staticRenderFns } from "./role.vue?vue&type=template&id=7421f7f7&scoped=true&"
import script from "./role.js?vue&type=script&lang=js&"
export * from "./role.js?vue&type=script&lang=js&"
import style0 from "./role.scss?vue&type=style&index=0&id=7421f7f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7421f7f7",
  null
  
)

export default component.exports